import React from "react";
// Reuses the existing shimmer keyframes rather than re-authoring them.
import "@components/SkeletonLoading/DashboardSkeleton.css";

/*
Single shimmer block. Width/height are inline because every call site wants a
different shape and there is no value in a class per size.
*/
export const TnSkeleton = function (props) {
  const style = {
    width: props.w || "100%",
    height: props.h || "14px",
    display: "block",
  };
  if (props.mb) style.marginBottom = props.mb;
  return <span className="skeleton-text" style={style} />;
};

// N stacked lines, for list-shaped cards (team velocity, table rows).
export const TnSkeletonRows = function (props) {
  const count = props.n || 3;
  const rows = [];
  for (let i = 0; i < count; i += 1) {
    rows.push(
      <div key={i} className="tn-skeleton-row">
        <TnSkeleton w="45%" h="13px" />
        <TnSkeleton w="20%" h="13px" />
      </div>
    );
  }
  return <div className="tn-skeleton-rows">{rows}</div>;
};

export default TnSkeleton;
